/**全局变量*/
const path = process.env.VUE_APP_BASE_API;
//上传URL
const uploadURL = 'http://cdn.deephealth.net:9333/submit'

//导出URL
//生产环境api  101.200.205.159
// const exportURL = path
// const exportURL = 'https://admin.deephealth.net'
// const exportURL = 'https://scm.deephealth.net'   // 正式环境
const exportURL = 'https://devpatient.deephealth.net/erp'   // 测试环境
// const exportURL = 'https://devscm.deephealth.net/erp'   // 开发环境
//接口本地调试api
//const exportURL = 'http://localhost:8083'
// const exportURL = 'https://devhealthadminapi.deephealth.net'
export default {
  uploadURL,
  exportURL
}



// WEBPACK FOOTER //
// ./src/api/global/globalVariable.js